// Custom brand mark for Shree Yamunesh Software Solutions.
// Two angular corner-brackets bridged by an electric-blue diagonal integration line,
// meeting at a central node — a distinctive brutalist symbol for "seamless integration."
export default function Logo({ size = 30, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="Shree Yamunesh Software Solutions"
      data-testid="site-logo"
    >
      {/* Outer square frame */}
      <rect
        x="1.5"
        y="1.5"
        width="33"
        height="33"
        stroke="currentColor"
        strokeWidth="1.5"
      />

      {/* Top-left corner bracket */}
      <path
        d="M6 15 L6 6 L15 6"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="square"
        strokeLinejoin="miter"
      />

      {/* Bottom-right corner bracket */}
      <path
        d="M21 30 L30 30 L30 21"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="square"
        strokeLinejoin="miter"
      />

      {/* Diagonal integration line (electric blue) */}
      <line
        x1="11"
        y1="11"
        x2="25"
        y2="25"
        stroke="#0033FF"
        strokeWidth="2.5"
        strokeLinecap="square"
      />

      {/* Central integration node */}
      <circle cx="18" cy="18" r="2.4" fill="#0033FF" />
    </svg>
  );
}
